import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home'
import Intro from '@/views/intro'
import NewsList from '@/views/newsList'
import NewsDetail from '@/views/newsDetail'
import WorksList from '@/views/worksList'
import WorksDetail from '@/views/WorksDetail'
import MyCenter from '@/views/myCenter'

import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '*',
      redirect: '/home'
    },
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/intro',
      name: 'Intro',
      component: Intro
    },
    {
      path: '/news',
      name: 'News',
      component: NewsList
    },
    {
      path: '/news/:id',
      name: 'NewsDetail',
      component: NewsDetail
    },
    {
      path: '/works',
      name: 'Works',
      component: WorksList
    },
    {
      path: '/works/:id',
      name: 'WorksDetail',
      component: WorksDetail
    },
    {
      path: '/myCenter',
      name: 'MyCenter',
      component: MyCenter
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
})

router.beforeEach((to, from, next) => {
  if (to.path == "/myCenter") {
    let token = window.localStorage.getItem("token")
    console.log(token);
    if (!token) {
      next('/')
    }
  }
  window.localStorage.setItem('headerName', to.name)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js